import classNames from 'classnames';
import Img, { Props as ImgProps } from '../../Atoms/Image';

interface Props {
  images: ImgProps[];
  className?: string;
}

function Mosaic({ images, className }: Props) {
  return (
    <div
      className={classNames([
        'mx-auto w-full overflow-hidden',
        className
      ])}
    >
      <div className="flex h-full w-full flex-wrap items-start justify-start">
        {images.map((img) => (
          <Img
            key={images.indexOf(img)}
            {...img}
            className={classNames([
              'w-1/3 object-cover object-center xl:h-auto',
              images.indexOf(img) === 4 && '-mt-[7%] w-2/3',
              images.indexOf(img) === 3 && '-mt-[12%]',
              images.indexOf(img) > 4 && 'hidden'
            ])}
          />
        ))}
      </div>
    </div>
  );
}

export default Mosaic;
